import React from "react";
import { Flex } from "reflexbox";
import { Body } from "../../UI/Text";
import { useTheme } from "styled-components";
import formatter from "../../../modules/formatter";

const DetailRow = ({ Detail, i }) => {
  const theme = useTheme();

  const { Value, Caption: _Caption } = Detail || {};
  let discount = 1;  
  const [priceCode, caption, ...rest] = _Caption.split(":");  
  
  let ii = 0;
  for (let item of rest) {
    if (item.includes("Discount")) {
      const discString = +rest[ii + 1].replace("%", "");
      discount = discString / 100;
    }
    ii += 1;
  } 

  if (Value.toLowerCase().includes("<img")) {   
    return <></>;
    // return (
    //   <Flex
    //     m="1rem auto"
    //     maxWidth="600px"
    //     key={Value + i}
    //     width={1}
    //     alignSelf="right"                
    //   >       
    //      <Body right><img src={`${formatter.extractUrl(Value)}`} alt={Value} style={{maxHeight: "150px"}} />   </Body>             
    //   </Flex>      
    // );
  }
  if (priceCode === "<br/>") return <br />;

  if (priceCode === "<hr/>") {
    return (
      <Flex
        m="1rem auto"
        maxWidth="600px"
        key={_Caption + Value + i}
        width={1}
        style={{
          borderBottom: `2px solid ${theme.borderColor}`,
        }}
      />
    );
  }
  if (priceCode?.startsWith("<b>")) {    
    return (
      <Flex
        m="0 auto"
        maxWidth="600px"
        key={caption + Value + i}
        width={1}
        alignSelf="right"
      >
        <Body flex={7} bold>
          {formatter.stripHtml(_Caption)}
        </Body>
        <Body right>{Value}</Body>
      </Flex>
    );
  }

  const Caption = (
    <Body>
      {formatter.stripHtml(caption)}:{" "}
      <span style={{ color: theme.secondary }}>
        {rest?.[0] === " " || rest?.[0] === "  " || !rest?.[0]
          ? ""
          : discount !== 1
          ? rest[0]?.split?.("Discount")?.[0]
          : rest}
      </span>
    </Body>
  );

  return (
    <Flex
      m="0 auto"
      maxWidth="600px"
      key={Caption + Value + i}
      width={1}
      alignSelf="right"
    >
      {" "}
      <Body flex={7} bold>
        {formatter.stripHtml(_Caption)}
      </Body>
      {!!Value && (
        <Body mr={0} w="auto !important" linethrough={discount !== 1} right>
          {!isNaN(Value.replace(",", "")) ? `$${Value}` : Value}
        </Body>
      )}
    </Flex>
  );
};

export default DetailRow;
